export enum Colors {
  Green =  "#1BC46F",
  CardWhite = "#DAE1E7",
  BackgroundGray = "#FAFAFA",
  LightBlue = "#2196F3",
  Red = "#F95D6A",
  Purple = "#8167B7",
  GrayText = "#5F6767",
  BlackText = "#3F4344",
  BlueText = "#696F8C",
  LightBlueText = "#8F95B2",
  GreenIconBox = "#E6FBF0",
  GrayIconBox = "#F4F6FA",
  BlueIconBox = "#E3EFFB",
  RedIconBox = "#FFF1F2",
  DarkGrayIconBox = "#E6E8F0",
  BorderGray = "#D8DAE5",
  HoverGreen = "#DDF6E9",
  OrangeIcon = "#FFA500",
}
